'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _withStyles = require('../with-styles');

var _withStyles2 = _interopRequireDefault(_withStyles);

var _styles = require('./styles');

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Ticker = function Ticker(_ref) {
  var classNames = _ref.classNames,
      label = _ref.label,
      _ref$items = _ref.items,
      items = _ref$items === undefined ? [] : _ref$items;
  return _react2.default.createElement(
    'div',
    { className: 'c11n-ticker ' + classNames.root },
    _react2.default.createElement(
      'ul',
      { className: classNames.items },
      items.map(function (item, index) {
        return _react2.default.createElement(
          'li',
          { className: classNames.item, key: index },
          item
        );
      })
    ),
    label && _react2.default.createElement(
      'div',
      { className: classNames.label },
      label
    )
  );
};

Ticker.propTypes = {
  /**
   * The background color
   */
  background: _propTypes2.default.string,

  /**
   * The color of the text
   */
  foreground: _propTypes2.default.string,

  /**
   * Items to display in animated scroll
   */
  items: _propTypes2.default.array.isRequired,

  /**
   * The label text
   */
  label: _propTypes2.default.string,

  /**
   * The label background color
   */
  labelBackground: _propTypes2.default.string,

  /**
   * The color of the label text
   */
  labelForeground: _propTypes2.default.string,

  /**
   * Animation speed
   */
  speed: _propTypes2.default.oneOf(['snail', 'slow', 'medium', 'fast']),

  /**
   * Custom styles to be applied
   */
  styles: _propTypes2.default.object
};

Ticker.defaultProps = {
  background: 'shade',
  foreground: 'dark',
  labelBackground: 'primary',
  labelForeground: 'light',
  speed: 'medium',
  styles: {}
};

exports.default = (0, _withStyles2.default)(_styles2.default, _styles.keyframes)(Ticker);


//////////////////
// WEBPACK FOOTER
// ../~/constructicon/ticker/index.js
// module id = 858
// module chunks = 0